import { useState } from 'react';

const useIsLoading = () => {
  const [counter, setCounter] = useState<number>(0);
  const isLoading = counter > 0;
  const setIsLoading = (v: boolean) => {
    setCounter(p => (v ? ++p : --p));
  };

  return {
    isLoading,
    setIsLoading
  };
};

export default useIsLoading;
